import { call } from 'redux-saga/effects';
import { takeLatest } from 'redux-saga';
import { SET_CURRENCY } from 'app/constants';
import handleChangeCurrency from './handleChangeCurrency';

export default function* watchChangeCurrency() {
  yield call(takeLatest, SET_CURRENCY, handleChangeCurrency);
}
